<template>
    <div class="flex-grid flex-grid--reduced-bottom-margin u-full-width flex-grid--wrap u-flex-center">
        <div class="p-compare-reserve__average-diff-chart">
            <h2 class="u-centre chart">Average Difference between {{fromLabel}} and {{toLabel}}</h2>
            <bar-chart :chart-data="currentChartData" :options="defaultOptions" :height="200" v-if="theCurrentWidth >= 600"></bar-chart>
        </div>
        <difference-table :average-from="averageFrom"
                          :average-to="averageTo"
                          :difference="averageDifference"
                          :from-label="fromLabel"
                          :to-label="toLabel"
                          :colours="colours">
        </difference-table>
    </div>
</template>

<script>

    import BarChart from 'components/graphs/BarChart';
    import {mapGetters} from 'vuex';
    import currencyFormat from "mixins/currencyFormat";
    import DifferenceTable from "./DifferenceTable";

    const labels = {
        "dayOne": 'Day One Reserve ',
        "paid": 'Paid',
        "final": 'Final Reserve',
        "initial": 'Initial Reserve',
    };

    export default {
        name: 'difference-chart',
        components: {
            DifferenceTable,
            BarChart
        },
        mixins: [
            currencyFormat
        ],
        data: () => ({
            colours: [
                '#45BFFC',
                '#3DF2C3',
                '#CD5CD8'
            ]
        }),
        computed: {
            ...mapGetters('reserves/compare', [
                'from',
                'to',
                'claims',
                'averageFrom',
                'averageTo',
                'averageDifference'
            ]),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            fromLabel() {
                return labels[this.from];
            },
            toLabel() {
                return labels[this.to];
            },
            defaultOptions() {
                return {
                    legend: {display: false},
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: label => this.currencyFormat(label, '£', 0),
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                            },
                            gridLines: {
                                display: true,
                                drawTicks: false,
                                color: 'rgba(255, 255, 255, 0)',
                                zeroLineWidth: 1,
                                zeroLineColor: 'rgba(0, 0, 0, 0.20)',
                                drawBorder: false
                            }
                        }],
                        xAxes: [
                            {
                                categoryPercentage: 1,
                                barPercentage: 0.75,
                                ticks: {
                                    fontSize: 14,
                                    fontFamily: "'Nunito', sans-serif",
                                    fontColor: "#000",
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'single',
                        callbacks: {
                            label: tooltipItems => this.currencyFormat(tooltipItems.yLabel)
                        }
                    }
                }
            },
            /**
             * Chart JS options for a bat chart.
             *
             * Bar: http://www.chartjs.org/docs/latest/charts/bar.html
             *
             * @return {{}}
             */
            currentChartData() {
                return {
                    type: 'bar',
                    labels: [
                        this.fromLabel,
                        this.toLabel,
                        "Difference"
                    ],
                    datasets: [
                        //Line Chart
                        {
                            backgroundColor: this.colours,
                            data: [
                                this.averageFrom,
                                this.averageTo,
                                Math.abs(this.averageDifference),
                            ]
                        },
                    ]
                }
            },
        }
    }

</script>


// WEBPACK FOOTER //
// DifferenceChart.vue?9023ff8a